import React from "react";
import Chart from "react-apexcharts";
import { COLORES_ESTABLECIMIENTO } from "./constants";
import { formatCurrency, truncarNombre } from "./utils";

export default function GraficoTopEstablecimientos(props) {
    const establecimientos = props.establecimientos || [];
    const valores = props.valores || [];
    const moneda = props.moneda || "PEN";
    const simbolo = moneda === "USD" ? "US$" : "S/";

    const options = {
        chart: {
            type: "bar",
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: "55%",
                borderRadius: 4,
                // Un color distinto por barra para que cada establecimiento
                // se identifique en la leyenda igual que en el grafico de
                // participacion (dona).
                distributed: true,
            },
        },
        colors: COLORES_ESTABLECIMIENTO,
        // El monto ya no se escribe encima de la barra (se cortaba o quedaba
        // centrado segun el ancho disponible); en su lugar se muestra en una
        // leyenda fija con nombre + monto, siempre visible sin pasar el mouse.
        dataLabels: { enabled: false },
        xaxis: {
            categories: establecimientos,
            title: { text: `Ventas (${simbolo})` },
            labels: {
                // Con montos chicos (< 1000) dividir entre 1000 siempre da "0K";
                // en ese caso se muestra el numero tal cual.
                formatter: (val) => (val >= 1000 ? `${Math.round(val / 1000)}K` : `${Math.round(val)}`),
            },
        },
        legend: {
            show: true,
            showForSingleSeries: true,
            position: "right",
            verticalAlign: "middle",
            fontSize: "12px",
            itemMargin: { vertical: 4 },
            // ApexCharts inserta este resultado como innerHTML, por eso
            // el <br/> corta la linea antes del monto.
            formatter: (nombre, opts) => ` ${formatCurrency(valores[opts.seriesIndex], moneda)}`,
        },
        tooltip: {
            x: {
                // El titulo del tooltip usa la categoria (nombre del
                // establecimiento) tal cual, sin pasar por la leyenda.
                formatter: (val) => truncarNombre(val),
            },
            y: {
                formatter: (val) => formatCurrency(val, moneda),
            },
        },
        grid: {
            padding: { left: 10, right: 10 },
        },
        // En pantallas angostas la leyenda a la derecha aprieta las barras;
        // ahi se pasa a leyenda inferior (mismo criterio que la dona).
        responsive: [
            {
                breakpoint: 992,
                options: {
                    legend: {
                        position: "bottom",
                        verticalAlign: "middle",
                        itemMargin: { horizontal: 8, vertical: 4 },
                    },
                },
            },
        ],
    };

    return (
        <Chart
            options={options}
            series={[{ name: "Ventas", data: valores }]}
            type="bar"
            height={320}
        />
    );
}
